import React, { FC } from 'react'
import { Grid } from '@mui/material'

export const Spacer: FC = () => <Grid item xs className='Hui-spacer' />
